'use client';
import Link from 'next/link';
import {usePathname} from "next/navigation";
import {FOOTER_PAGES, FooterPage, HashMapPathName, isActiveTab} from '@/app/config';
import {useAppSelector} from "@/app/storeHooks";
import styles from "./footer.module.css";
import {selectMainState} from "@/app/MainSlice";
import ChannelMgr from "@/Fwk/Channel/ChannelMgr";
import TrackCommon2 from "@/Core/Track/TrackCommon2";

export default function Footer() {
    const pathname = usePathname();
    const {isKycPending} = useAppSelector(selectMainState);
    if (!HashMapPathName(FOOTER_PAGES, pathname)) {
        return null;
    }

    const isShowDot = (row: FooterPage) => {
        if (row.name == 'REDEEM') {
            if (isKycPending){
                return true;
            }
        }
        return false;
    }

    const getUrl = (row: FooterPage) => {
        let url = `/${row.url === "/" ? "" : row.url}`
        if (ChannelMgr.channelQid){
            url+=`?qid=${ChannelMgr.channelQid}`
        }
        return url;
    }

    const onClickBtn = (row: FooterPage) => {
        if (row.name == 'STORE'){
            TrackCommon2.iapPageClick(3);
        }
    }

    return (
        <>
            <footer className={styles.footer}>
                <div className={`${styles.footer_main} center`}>
                    {FOOTER_PAGES.map((row) =>
                        <Link
                            id={row.nodeId}
                            className={`${styles.tab} ${isActiveTab(row.url, pathname) ? styles.tab_curr : ''}`}
                            href={getUrl(row)}
                            key={row.name}
                            onClick={()=>{
                                onClickBtn(row);
                            }}
                        >
                            <div className={styles.tab_box}>
                                <span className={`s-icon ${row.iconClass} ${styles.tab_icon}`}></span>
                                <div className={`center`}>
                                    <span className={`s-icon ${row.textClass} ${styles.tab_title_active}`}></span>
                                    <div className={styles.tab_title} style={{marginTop: '.1rem'}}>{row.name}</div>
                                </div>

                                {
                                    isShowDot(row) && (
                                        <div className={`${styles.tab_dot} dotAni`}></div>
                                    )
                                }
                            </div>
                        </Link>
                    )}
                </div>
            </footer>
            <div className="footer_panel"></div>
        </>
    )
}
